import { render, staticRenderFns } from "./PublisherSetupTabFilter.vue?vue&type=template&id=2485b280"
import script from "./PublisherSetupTabFilter.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports